import { W_BREAKPOINT_VIEWPORT_S as E, W_BREAKPOINT_VIEWPORT_M as t, W_BREAKPOINT_VIEWPORT_L as n, W_BREAKPOINT_VIEWPORT_XL as O, W_BREAKPOINT_VIEWPORT_XXL as T } from "./watson.es87.js";
import { getBreakpointValue as _ } from "./watson.es42.js";
const P = "date", C = "email", r = "number", L = "password", S = "search", A = "tel", i = "text", a = "time", U = "url", I = "none", s = "small", c = "medium", o = "large", R = "xlarge", d = [
  I,
  s,
  c,
  o,
  R
], D = "primary", W = "secondary", m = "muted", V = "inverted", Y = "accent", M = "info", l = "info-inverted", B = "success", u = "warning", K = "danger", g = "accent-inverted", p = "success-inverted", X = "danger-inverted", Z = "fixed", f = "sticky", v = _(
  E
);
_(
  t
);
_(
  n
);
_(
  O
);
_(
  T
);
export {
  v as BREAKPOINT_VIEWPORT_S,
  Y as COLOR_ACCENT,
  g as COLOR_ACCENT_INVERTED,
  K as COLOR_DANGER,
  X as COLOR_DANGER_INVERTED,
  M as COLOR_INFO,
  l as COLOR_INFO_INVERTED,
  V as COLOR_INVERTED,
  m as COLOR_MUTED,
  D as COLOR_PRIMARY,
  W as COLOR_SECONDARY,
  B as COLOR_SUCCESS,
  p as COLOR_SUCCESS_INVERTED,
  u as COLOR_WARNING,
  P as INPUT_TYPE_DATE,
  C as INPUT_TYPE_EMAIL,
  r as INPUT_TYPE_NUMBER,
  L as INPUT_TYPE_PASSWORD,
  S as INPUT_TYPE_SEARCH,
  A as INPUT_TYPE_TEL,
  i as INPUT_TYPE_TEXT,
  a as INPUT_TYPE_TIME,
  U as INPUT_TYPE_URL,
  Z as POSITION_FIXED,
  f as POSITION_STICKY,
  d as SIZES,
  o as SIZE_LARGE,
  c as SIZE_MEDIUM,
  I as SIZE_NONE,
  s as SIZE_SMALL,
  R as SIZE_XLARGE
};
